// NOTE : Above ESLint disable was needed because for some reason eslint complaint history is not installed even when its installed and available in package.json.
//        Also note that we must use "history 4.X.X" version to be compatible with "react-router-dom 5.X.X" version.

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;
